// pages/FormViewerPage/components/VariantOptions/ModernOption.tsx — Modern style variant
import React from 'react';
import type { Form } from '../../../../types';
import { formatMoney } from '../../../../utils/formatMoney';
import { singleLockGroup } from '../../../../utils/regionPricing';
import type { ProductOption, VariantCombination } from './types';

export const ModernOption: React.FC<{
    option: ProductOption;
    selectedOptions: Record<string, string>;
    onOptionChange: (name: string, value: string) => void;
    getVariantDetails: (name: string, val: string) => VariantCombination | null;
    currentVariantStock: number | undefined;
    form: Form;
}> = ({ option, selectedOptions, onOptionChange, getVariantDetails, currentVariantStock, form }) => (
    <div className="divide-y divide-slate-100 dark:divide-slate-700/50 border-y border-slate-100 dark:border-slate-700/50">
        {option.values.map(val => {
            const details = getVariantDetails(option.name, val);
            const isSelected = selectedOptions[option.name] === val;
            return (
                <button type="button" key={val} onClick={() => onOptionChange(option.name, val)} className={`w-full flex justify-between items-center gap-2 px-1 py-2.5 text-sm transition-colors font-medium ${isSelected ? 'bg-orange-50/60 dark:bg-orange-900/20 text-slate-900 dark:text-slate-100' : 'text-slate-700 dark:text-slate-300'}`}>
                    <div className="flex items-center gap-2.5 flex-wrap">
                        <span aria-hidden className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${isSelected ? 'border-orange-600' : 'border-slate-300 dark:border-slate-500'}`}>
                            {isSelected && <span className="w-2.5 h-2.5 rounded-full bg-orange-600" />}
                        </span>
                        <span className={isSelected ? 'font-semibold' : ''}>{val}</span>
                        {form?.defaultVariant === val && (
                            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-amber-100 dark:bg-amber-950/60 text-amber-800 dark:text-amber-200 border border-amber-300 dark:border-amber-700">
                                ⭐ Rekomendasi
                            </span>
                        )}
                    </div>
                    {option.showPrice !== false && (!(form.productRegionGroups?.length) || singleLockGroup(form)) && details?.sellingPrice != null && (
                        <span className="text-xs font-semibold whitespace-nowrap text-slate-700 dark:text-slate-300">
                            {formatMoney(details.sellingPrice, form)}
                            {details.strikethroughPrice != null && details.strikethroughPrice > details.sellingPrice && (
                                <span className="ml-1.5 font-normal text-slate-400 line-through">{formatMoney(details.strikethroughPrice, form)}</span>
                            )}
                        </span>
                    )}
                </button>
            );
        })}
    </div>
);
